<script setup>
import $ from "jquery";
import BpmnModeler from "bpmn-js/lib/Modeler";
import { getNodeInfo } from "@/api//bpmnApi";
import { ref, reactive, watch, nextTick } from "vue";

const props = defineProps({
  xmlStr: {
    type: String,
    default: "",
  },
});

const bpmnModeler = ref();

const myXmlStr = ref("");

const processView = ref(null);

const initBpmn = async () => {
  bpmnModeler.value?.destroy();
  bpmnModeler.value = null;
  // const canvas = window.appDocument.querySelector("processView");
  bpmnModeler.value = new BpmnModeler({
    container: processView.value,
    additionalModules: [
      {
        paletteProvider: ["value", ""], //禁用/清空左侧工具栏
        labelEditingProvider: ["value", ""], //禁用节点编辑
        contextPadProvider: ["value", ""], //禁用图形菜单
        bendpoints: ["value", {}], //禁用连线拖动
        zoomScroll: ["value", ""], //禁用滚动
        //moveCanvas:['value',''],//禁用拖动整个流程图
        move: ["value", ""], //禁用单个图形拖动
      },
    ],
  });

  try {
    const result = await bpmnModeler.value.importXML(myXmlStr.value);
    const { warning } = result;
    // 让图能自适应屏幕
    const canvas = bpmnModeler.value.get("canvas");
    canvas.zoom("fit-viewport", "auto");
    const overlays = bpmnModeler.value.get("overlays");
    const arr = bpmnModeler.value.get("elementRegistry")._elements;
    Object.getOwnPropertyNames(arr).forEach((e) => {
      let item = arr[e].element;
      console.log(item.type);
      if (item && item.type == "bpmn:UserTask") {
        let o = item.businessObject;
        let taskId = o.id;
        let node = {};
        node.assignee = o.$attrs["camunda:assignee"];
        node.candidateGroups = o.$attrs["camunda:candidateGroups"];
        node.candidateUsers = o.$attrs["camunda:candidateUsers"];
        if (
          o.loopCharacteristics &&
          o.loopCharacteristics.$attrs["camunda:collection"]
        ) {
          node.assignee = null;
          node.collection = o.loopCharacteristics.$attrs["camunda:collection"];
        }
        getNodeInfo(node).then((res) => {
          overlays.add(taskId, "note", {
            position: {
              top: 0,
              right: -5,
            },
            html: `<div id="${taskId}_note" style="display: none; background-color: white;width: 200px;box-shadow: 2px 2px 3px 0px #ccc;border-radius: 5px;border: 1px solid #ccc;padding: 5px;font-size: 14px;">
                          <div style="text-align: center;font-size: 16px;border-bottom: 1px solid #ccc;">${
                            o.name
                          }</div>
                          <div style="display: ${
                            res.data.assignee == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">代理人：</div><div>${
                              res.data.assignee
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.collection == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">会签人：</div><div>${
                              res.data.collection
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.candidateGroups == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">候选组：</div><div>${
                              res.data.candidateGroups
                            }</div>
                          </div>
                          <div style="display: ${
                            res.data.candidateUsers == null ? "none" : "flex"
                          };">
                            <div style="width: 60px;flex: none;">候选人：</div><div>${
                              res.data.candidateUsers
                            }</div>
                          </div>
                        </div>`,
          });
        });
      }
    });
    initEvent();
  } catch (err) {
    console.error(err.message, err.warning);
  }
};

const initEvent = () => {
  const eventBus = bpmnModeler.value.get("eventBus"); // 需要使用eventBus
  const eventTypes = ["element.hover", "element.out"]; // 需要监听的事件集合
  // const modeling = viewer.get('modeling')
  const elementRegistry = bpmnModeler.value.get("elementRegistry");
  const overlays = bpmnModeler.value.get("overlays");
  eventTypes.forEach((eventType) => {
    eventBus.on(eventType, (e) => {
      //排除根节点元素，也就是画布
      var shape = e.element ? elementRegistry.get(e.element.id) : e.shape;
      if (e && shape.type == "bpmn:UserTask") {
        var o = shape.businessObject;
        var taskId = o.id;
        if ($("#" + taskId + "_note")[0]) {
          $("#" + taskId + "_note").toggle();
        }
      }
    });
  });
};

watch(
  () => props.xmlStr,
  (newVal) => {
    if (newVal) {
      myXmlStr.value = newVal;
      nextTick(() => {
        initBpmn();
      });
    }
  },
  {
    immediate: true,
  }
);
</script>

<template>
  <div class="container">
    <div class="h-title">流程图</div>
    <div id="processView" ref="processView"></div>
  </div>
</template>

<style scoped>
.container {
  width: 100%;
}
.h-title {
  border-left: 5px solid #1a7bb9;
  font-size: 20px;
  font-weight: bold;
  padding-left: 10px;
  margin-bottom: 15px;
}
#processView {
  height: 300px;
  width: 100%;
}
.bjs-powered-by {
  display: none;
}
.note {
  display: none;
  background-color: white;
  width: 200px;
  box-shadow: 2px 2px 3px 0px #ccc;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding: 5px;
}
</style>
